export default __webpack_public_path__ + "static/icon-39cdbe5efaf3379a29a1947d0a657a81.png";